import { Component, ChangeDetectorRef } from '@angular/core';
import { AbstractWidgetComponent } from '../abstract.widget';
import { WidgetConfiguration } from '../../../models/widget-configuration.model';
import { WidgetsHelper } from '../widgets.helper';

// @dynamic
@Component({
  selector: 'interface-datatable',
  template: `<ng-container *ngIf="!preview; else previewTemplate">
  <datagrid-viewer *ngIf="rows && config" [rows]="config?.rows" [config]="config" [advancedSearch]="false" [hideNav]="true"
    [headerHeight]="50" [footerHeight]="50" [rowHeight]="50" columnMode="force" [scrollbarH]="config?.scrollbarH"
    [scrollbarV]="config?.scrollbarV" [hideNav]="config?.hideNav" [advancedSearch]="config?.advancedSearch" [rowHeight]="config?.rowHeight"
    [headerHeight]="config?.headerHeight" [footerHeight]="config?.footerHeight" [showPager]="config?.showPager"
    [reorderable]="config?.reorderable" [swapColumns]="config?.swapColumns" [resizable]="config?.resizable" [sortable]="config?.sortable"
    [editablePageSize]="config?.editablePageSize" [pageSizes]="config?.pageSizes" [actionButtons]="config?.actionButtons"
    [selected]="config?.selected" [class]="config?.class">
  </datagrid-viewer>
</ng-container>
<ng-template #previewTemplate>
  <div draggable="true" (dragstart)="dragStartHandler($event, { cols: 2, rows: 2})">
    <interface-widget-preview [data]="sanitizeData(true)"></interface-widget-preview>
  </div>
</ng-template>`,
  styles: [`.material{height:100%;position:relative}`],
})
export class DatatableWidgetComponent extends AbstractWidgetComponent {
  constructor(protected ref: ChangeDetectorRef) {
    super(ref);
  }

  rows = [
    { name: 'Austin', gender: 'Male', company: 'Swimlane' },
    { name: 'Dany', gender: 'Male', company: 'KFC' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
    { name: 'Molly', gender: 'Female', company: 'Burger King' },
  ];

  columns = [
    { prop: 'name' },
    { name: 'Gender' },
    { name: 'Company' },
  ];

  config = {
    availableColumns: this.columns,
    displayedColumns: this.columns,
    rows: this.rows,
    scrollbarH: true,
    scrollbarV: true,
    hideNav: true,
    advancedSearch: false,
    rowHeight: 35,
    headerHeight: 50,
    footerHeight: 0,
    showPager: false,
    reorderable: false,
    swapColumns: false,
    resizable: false,
    sortable: false,
    editablePageSize: false,
    pageSizes: 10,
    actionButtons: [],
    selected: [],
    class: 'material full-width',
  };

  // Mandatory fields
  static get CONFIGURATION(): WidgetConfiguration[] {
    return [
      ...WidgetsHelper.defaultConfigurations,
      { key: 'data_view', name: 'Data Endpoint', type: 'text' },
    ];
  }

  static get OPTIONS() {
    return Object.assign(
      WidgetsHelper.defaultOptions,
      {
        cols: {
          max: 4,
          min: 1,
        },
        rows: {
          max: 4,
          min: 1,
        },
      },
    );
  }

  static get DESCRIPTION() {
    return 'Widget for rendering grids';
  }

  static get TITLE() {
    return 'Datatable';
  }

  static get ICON() {
    return 'fa fa-table fa-4x';
  }
  // Mandatory fields end
}
